<template>
  <div class="channl-code-edit">
    <el-form
      ref="form"
      :rules="ruleForm"
      :model="form"
      label-width="120px"
    >
      <SpCardContent title="基础信息">
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="活码名称："
              prop="channel_name"
            >
              <el-input
                v-model="form.channel_name"
                placeholder="请输入活码名称"
                size="small"
                maxlength="50"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              label="导购人员："
              prop=""
            >
              <template v-if="showList.length <= 0">
                <el-button
                  icon="el-icon-plus"
                  type="primary"
                  @click="showBox = true"
                >
                  添加人员
                </el-button>
              </template>

              <template v-else>
                <div
                  class="el-button"
                  @click="showBox = true"
                >
                  <div class="guide-box">
                    <template v-for="(item, index) in showList">
                      <div
                        v-if="item.work_userid"
                        :key="index"
                        class="guide-number"
                      >
                        <img
                          v-if="item.salesperson_avatar"
                          :src="item.salesperson_avatar"
                          alt=""
                          class="pic"
                        >
                        {{ item.salesperson_name }}
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <span
                class="tips"
                style="margin-left: 16px"
              >&nbsp;同一个二维码关联多个导购，客户扫码后随机分配一名导购人员</span>
              <!-- <SpComponent
                v-if="SPCompanyId"
                v-model="showBox"
                :show-type="showBox"
                default-component="SpGuideBox"
                my-name="guideSelelct"
                :store-visible="showBox"
                :call-data="callData"
                :disabled-node="true"                
                @chooseStore="chooseStore"
                @getUserList="getUserList"
                @getUserList1="getInfo"
              /> -->
              <!-- <component
                :is="boxType[SPCompanyId] || 'SpGuideBox'"
                v-if="SPCompanyId"
                v-model="showBox"
                :store-visible="showBox"
                :call-data="callData"
                :disabled-node="true"
                @chooseStore="chooseStore"
                @getUserList="getUserList"
                @getUserList1="getInfo"
              /> -->
              <!-- <SpStoreSelect
                :store-visible="showBox"
                :select-data="selectStoreData"
                @closeStoreDialog="closeStoreDialog"
                @chooseStore="chooseStore"
              />  -->
              <SpGuideBox
                v-model="showBox"
                :call-data="callData"
                :disabled-node="true"
                @getUserList="getUserList"
              />
            </el-form-item>
            <el-form-item label="客户备注：">
              <!-- <div class="feature-set">
                <el-switch
                  v-model="form.is_open_remark"
                  :active-value="1"
                  :inactive-value="2"
                />
              </div> -->
              <el-input
                v-model="form.remark"
                type="textarea"
                placeholder="请输入客户备注"
                maxlength="150"
                show-word-limit
              />
              <div>
                <span class="tips">非必填项，填写后可为客户昵称加备注，方便查看客户来源</span>
                <!-- <span class="sample">查看示例</span> -->
              </div>
            </el-form-item>
            <el-form-item label="客户描述：">
              <!-- <div class="feature-set">
                <el-switch
                  v-model="form.is_open_describe"
                  :active-value="1"
                  :inactive-value="2"
                />
              </div> -->
              <el-input
                v-model="form.describe"
                type="textarea"
                placeholder="请输入客户描述内容"
                maxlength="150"
                show-word-limit
              />
              <div>
                <span class="tips">非必填项，填写后可为客户添加描述，将在客户画像里展示</span>
                <!-- <span class="sample">查看示例</span> -->
              </div>
            </el-form-item>
            <el-form-item label="选择标签：">
              <div class="babel-list-box">
                <el-tag
                  v-for="tag in form.tags"
                  :key="tag.id"
                  closable
                  type="info"
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{ tag.title }}
                </el-tag>
                <el-button
                  icon="el-icon-plus"
                  class="add-label-btn"
                  @click="showBatchTagging = true"
                >
                  添加标签
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </SpCardContent>

      <div class="welcome-box">
        <SpWelcome
          :form="form"
          :show-radio="true"
        />
      </div>

      <SpCardContent title="功能设置">
        <el-row>
          <el-col :span="16">
            <el-form-item
              label="好友自动通过："
              class="feature-set"
            >
              <el-switch
                v-model="form.is_auto_verify"
                :active-value="1"
                :inactive-value="2"
              />
              <span
                class="tips"
                style="margin-left: 16px"
              >客户添加该企业微信时，自动添加成功无需验证</span>
            </el-form-item>
          </el-col>
        </el-row>
      </SpCardContent>

      <div class="fotter-toolbar">
        <el-button
          type="primary"
          :loading="loading"
          @click="onSubmit"
        >
          立即创建
        </el-button>
      </div>
    </el-form>

    <SpBatchLabel
      v-model="showBatchTagging"
      :tags-list="form.tags"
      :selection-babel="true"
      :show-selected-tags="true"
      @selectBabelList="batchTagging"
    />
  </div>
</template>

<script>
import { getUrlRelativePath } from '@/utils'
export default {
  name: 'ChannelCodeEdit',
  data () {
    return {
      ruleForm: {
        channel_name: [{ required: true, message: '活码名称不能为空', trigger: 'blur' }]
      },
      loading: false,
      showBox: false,

      callData: {},
      form: {
        channel_name: '', //渠道名称
        is_open_remark: 1, //是否开启客户备注 1开启 2不开启
        remark: '', //客户备注
        is_open_describe: 1, //是否开启客户描述 1开启 2不开启
        describe: '', //客户描述
        msg_setting_type: 1, //设置欢迎语类型 1渠道欢迎语 2默认欢迎语 3不使用欢迎语
        is_auto_verify: 1, //是否开启好友自动通过 1开启 2不开启

        channel_source: 2, //渠道来源：0新客，1社群，2活码
        work_userid: '',
        text_msg: '',
        msg_type: 0, //消息类型：0图片，1链接，2小程序
        content: {
          image: {
            img_url: '',
            image_type: 'image/png'
          },
          link: {
            title: '链接',
            url: '',
            picurl: '',
            desc: ''
          },
          miniprogram: {
            title: '',
            img_url: '',
            page: '',
            image_type: 'image/png'
          }
        },
        attachments: [],
        tags: []
      },
      showList: [],
      dynamicCodeId: 0,
      showBatchTagging: false
    }
  },
  mounted () {
    let params = this.$route.params
    if (+params.id) {
      this.dynamicCodeId = params.id
      this.getInfo(params.id)
    }
  },
  methods: {
    chooseStore (val) {
      console.log('chooseStore', val)
      this.showBox = val
    },
    // 获取详情
    async getInfo (id) {
      const data = await this.$api.drainage.getChannelCodeInfo({ dynamic_code_id: id })
      if (!data.content) {
        data.content = {}
      }

      if (data) {
        // 兼容老数据
        if (data.content.image) {
          data.content.image.pic_url = data.content.image.img_url
          data.attachments = [
            {
              msgtype: 'image',
              image: data.content.image
            }
          ]
        } else if (data.content.link) {
          data.attachments = [
            {
              msgtype: 'link',
              link: data.content.link
            }
          ]
        } else if (data.content.miniprogram) {
          data.attachments = [
            {
              msgtype: 'miniprogram',
              miniprogram: data.content.miniprogram
            }
          ]
        } else {
          data.attachments = []
        }
        console.log(data, '处理过的接口返回数据')
        this.form = data
      }
      // 重新处理表单数据
      this.guideData(data)
    },
    onSubmit () {
      this.loading = true
      let params = {
        ...this.form,
        content: {}
      }

      if (this.form.attachments && this.form.attachments.length > 0) {
        // 兼容老数据
        let attachment = this.form.attachments[0]
        if (attachment.msgtype === 'image') {
          attachment.image.img_url = attachment.image.pic_url
        }
        params.content[attachment.msgtype] = attachment[attachment.msgtype]
      }

      if (params.salesperson && !this.form.work_userid) {
        params.work_userid = params.salesperson.map((v) => v.work_userid)
      }

      if (params.tags && params.tags.length > 0) {
        params.tags_id = params.tags.map((v) => v.id)
      }

      this.$refs['form'].validate(async (valid) => {
        this.loading = false
        if (valid) {
          let requestUrl
          if (this.dynamicCodeId) {
            params.dynamic_code_id = this.dynamicCodeId
            requestUrl = this.$api.drainage.updateChannelCode
          } else {
            requestUrl = this.$api.drainage.saveChannelCode
          }
          const data = await requestUrl(params).catch(() => {
            this.loading = false
          })

          if (data) {
            this.loading = false
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$router.push({ path: '/drainage/channelCode', replace: true })
          }
        } else {
          this.$message.error('请先填写必要信息')
          return false
        }
      })
    },
    getUserList (e) {
      console.log(e, '返回的数据000')
      if (e.userList.length > 100) {
        return this.$message.error('导购选择不能超过100条')
      }

      if (e.userList.length > 0) {
        e.userList.map((v) => {
          v.salesperson_name = v.name
        })
      }
      this.showBox = false
      this.callData = e
      this.showList = [].concat(e.userList).slice(0, 2)
      this.getIds(e)
    },

    getIds (data) {
      let userListId = []
      data.userList.forEach((v) => {
        userListId.push(v.work_userid)
      })
      this.form.work_userid = userListId
    },

    // 处理导购数据
    guideData (data) {
      if (data.salesperson.length > 0) {
        data.salesperson.map((v) => {
          v.name = v.salesperson_name
          v.userid = v.salesperson_id
        })
      }
      this.callData = {
        userList: data.salesperson
      }
      this.showList = [].concat(data.salesperson).slice(0, 2)
      this.getIds(this.callData)
    },

    handleClose (tag) {
      let index = this.form.tags.findIndex((v) => v.id === tag.id)
      this.form.tags.splice(index, 1)
    },
    batchTagging (list) {
      this.form.tags = list
      this.showBatchTagging = false
    }
  }
}
</script>

<style lang="scss" scoped>
.channl-code-edit {
  padding-bottom: 40px;
}
.el-divider--horizontal {
  margin-top: 10px;
}
.feature-set {
  .sample {
    color: #409eff;
    font-size: 12px;
    margin-left: 10px;
    cursor: pointer;
  }
}
.tips {
  color: #999;
  font-size: 12px;
}

.guide-box {
  display: flex;
  align-items: center;
  width: auto;
  .guide-number {
    display: flex;
    align-items: center;
    .pic {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 50%;
    }
    margin-right: 10px;
  }
  .guide-deparment {
    display: flex;
    align-items: center;
    .pic-folder {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url('../../assets/img/folder.png') no-repeat;
      background-size: contain;
      margin-right: 4px;
    }
  }
}
.welcome-box {
  background-color: #fff;
  margin-bottom: 20px;
}

.babel-list-box {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .add-label-btn {
    padding: 0 6px;
    height: 32px;
    font-size: 12px;
    margin-bottom: 10px;
  }
}
</style>
